import React, { useState } from 'react';
import { BringzzBottomDrawer, BringzzIcon, BringzzText, BringzzInput, BringzzButton } from '@bringzz/components';
import { useTranslation } from 'react-i18next';

const BookmarkCollectionDrawer = ({ 
  isOpen, 
  onClose, 
  collections, 
  onSelectCollection, 
  onCreateCollection 
}) => {
  const { t } = useTranslation();
  const [showNewCollectionInput, setShowNewCollectionInput] = useState(false);
  const [newCollectionName, setNewCollectionName] = useState('');

  const handleCreateCollection = async () => {
    if (!newCollectionName.trim()) return;
    await onCreateCollection(newCollectionName);
    setNewCollectionName('');
    setShowNewCollectionInput(false);
  };

  const handleClose = () => {
    setShowNewCollectionInput(false);
    setNewCollectionName('');
    onClose();
  };

  return (
    <BringzzBottomDrawer
      isOpen={isOpen}
      close={handleClose}
      title={t('component.bookmarks.select_collection')}
    >
      <div className="px-6 py-4">
        <div 
          className="flex items-center p-3 hover:bg-gray-50 rounded-lg cursor-pointer mb-2"
          onClick={() => onSelectCollection()}
        >
          <BringzzIcon icon="IconBookmark" folder="LineIcons" size="20" className="mr-3" />
          <BringzzText>{t('component.bookmarks.save_without_collection')}</BringzzText>
        </div>
        
        {collections && collections.length > 0 ? (
          collections.map((collection) => (
            <div 
              key={collection.id}
              className="flex items-center p-3 hover:bg-gray-50 rounded-lg cursor-pointer mb-2"
              onClick={() => onSelectCollection(collection.integrationId)}
            >
              <BringzzIcon icon="IconFolder" folder="LineIcons" size="20" className="mr-3" />
              <BringzzText>{collection.name}</BringzzText>
            </div>
          ))
        ) : null}
        
        {showNewCollectionInput ? (
          <div className="p-3 border rounded-lg">
            <BringzzInput
              placeholder={t('component.bookmarks.collection_name')}
              value={newCollectionName}
              onChange={(e) => setNewCollectionName(e.target.value)}
              className="mb-3"
            />
            <div className="flex space-x-2">
              <BringzzButton
                size="sm"
                onClick={handleCreateCollection}
                disabled={!newCollectionName.trim()}
              >
                {t('component.bookmarks.create')}
              </BringzzButton>
              <BringzzButton
                size="sm"
                variant="secondary"
                onClick={() => {
                  setShowNewCollectionInput(false);
                  setNewCollectionName('');
                }}
              >
                {t('component.bookmarks.cancel')}
              </BringzzButton>
            </div>
          </div>
        ) : (
          <div 
            className="flex items-center p-3 hover:bg-gray-50 rounded-lg cursor-pointer border-2 border-dashed border-gray-300"
            onClick={() => setShowNewCollectionInput(true)}
          >
            <BringzzIcon icon="IconPlus" folder="LineIcons" size="20" className="mr-3" />
            <BringzzText>{t('component.bookmarks.create_new_collection')}</BringzzText>
          </div>
        )}
      </div>
    </BringzzBottomDrawer>
  );
};

export default BookmarkCollectionDrawer;